import React from 'react';
import { useField } from 'formik';
import { map, remove } from 'lodash/fp';
import { Box, Chip } from '@material-ui/core';
import AutocompleteField, { AutocompleteFieldProps } from './AutocompleteField';
import { Options } from './types';
import { ChipsWrapper } from './style';

const MultipleAutocompleteField = ({ name, ...other }: AutocompleteFieldProps) => {
    const [, meta, helpers] = useField<Options[]>(name);

    const { value: chips } = meta;
    const { setValue: setChips } = helpers;

    const handleChange = (e: React.ChangeEvent, values: Options[]) => {
        setChips(values);
    };

    const handleChipDelete = (chip: Options) => () => {
        const newChips = remove(chip, chips);
        setChips(newChips);
    };

    return (
        <Box display="flex" flexDirection="column">
            <AutocompleteField
                {...other}
                value={chips}
                renderTags={() => null}
                // @ts-ignore
                onChange={handleChange}
                multiple
            />
            <ChipsWrapper>
                {map(chip => (
                    <Chip key={chip.id} color="primary" onDelete={handleChipDelete(chip)} label={chip.name} />
                ), chips)}
            </ChipsWrapper>
        </Box>
    );
};

export default MultipleAutocompleteField;
